/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchGetMerchantRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {BatchGetMerchantResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const batchGetMerchant = (request: BatchGetMerchantRequest, options?: CashRequestOptions) => post<BatchGetMerchantRequest, BatchGetMerchantResponse>("/2.0/cash/batch-get-merchant", request, {...options, rejectOnError: true })